function normalizeRuntimeMode(raw: unknown): string {
  return String(raw || "")
    .trim()
    .toLowerCase();
}

function isLocalHostname(hostname: string): boolean {
  const host = String(hostname || "")
    .trim()
    .toLowerCase();
  return host === "localhost" || host === "127.0.0.1" || host === "[::1]";
}

export function isWalletCloudMode(): boolean {
  const forced = normalizeRuntimeMode(import.meta.env.VITE_WALLET_RUNTIME_MODE);
  if (forced === "cloud" || forced === "hosted") return true;
  if (forced === "daemon" || forced === "local") return false;

  if (typeof window === "undefined") return false;
  return !isLocalHostname(window.location.hostname || "");
}

export function isWalletDaemonMode(): boolean {
  return !isWalletCloudMode();
}

// Existing GENRL deployments predate the host-resolved instance manifest.
// Company deployments set this flag explicitly; until the default GENRL
// registry row is migrated, a bootstrap outage must not brick the legacy app.
export function isInstanceBrandingRequired(): boolean {
  const configured = normalizeRuntimeMode(import.meta.env.VITE_INSTANCE_BRANDING_REQUIRED);
  return configured === "true" || configured === "1" || configured === "yes";
}

export function hasBundledInstanceBranding(): boolean {
  return String(import.meta.env.VITE_INSTANCE_BOOTSTRAP_JSON || "").trim().length > 0;
}
